import { render, staticRenderFns } from "./gl-loader.vue?vue&type=template&id=448a2442"
import script from "./gl-loader.vue?vue&type=script&lang=js"
export * from "./gl-loader.vue?vue&type=script&lang=js"
import style0 from "./gl-loader.vue?vue&type=style&index=0&id=448a2442&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports